import React, { useContext, useRef, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { Button, Container, Grid, IconButton, Paper, TextField, Typography } from '@mui/material'
import { EMDESENVOLVIMENTO } from '../../ImportBackend/Config/emDesenvolvimento'
import { useNavigate } from 'react-router-dom'

import CloseIcon from '@mui/icons-material/Close'
import ComboBox from '../../DevComponents/ComboBox'
import { GerarOrdemServicoInputInterface, OrdemServicoInterface } from '../../ImportBackend/Interfaces/OrdensServicosInterfaces'
import { FilialTypes, FilialTypesInterface } from '../../ImportBackend/types/ConstantesDataTypes'
import SearchText from '../../DevComponents/SearchText'
import Condicional from '../../Layout/Condicional'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'
import { ListarClientesOmieInterface, ParcelasOmieInterface } from '../../ImportBackend/Interfaces/OmieInterfaces'
import BackEndAPI from '../../Services/BackEndAPI'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import InputText from '../../DevComponents/InputText'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import ClsEnviarOS from './EnviarOSCls'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import { clsUtils } from 'zlib-utils'

interface PesquisaInterface {
  descricao: string
}

export default function EnviarOS () {

  const clsEnviarOS: ClsEnviarOS = new ClsEnviarOS()

  const contexto = ( useContext( ContextoGlobal ) as ContextoGlobalInterface )

  const refreshKey = useRef<number>( 0 )

  const { setMensagemState } = contexto

  const navigate = useNavigate()

  const clsApi = new BackEndAPI()

  const abortController: AbortController = new AbortController()

  const ResetDados: GerarOrdemServicoInputInterface = {
    codigo_cliente: 0,
    idFilial: '',
    idOrdemServico: [],
    valorTotal: 0,
    dadosAdicionaisNF: "",
    descricaoServico: "",
    codigoParcela: "",
    email: "",
    obs_detalhadas: ""
  }

  const [dados, setDados] = useState<GerarOrdemServicoInputInterface>( ResetDados )
  const [rsClienteSelecionado, setRsClienteSelecionado] = useState<ListarClientesOmieInterface | null>( null )
  const [rsSelecao, setRsSelecao] = useState<Array<number>>( [] )

  const [rsParcelas, setRsParcelas] = useState<Array<ParcelasOmieInterface>>( [] )

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'numeroOS',
      cabecalho: 'OS',
      alinhamento: 'left'
    },
    {
      campo: 'empresa',
      cabecalho: 'Empresa',
      alinhamento: 'left'
    },
    {
      campo: 'proprietario',
      cabecalho: 'Proprietário',
      alinhamento: 'left'
    },
    {
      campo: 'tipoAnalise',
      cabecalho: 'Análise',
      alinhamento: 'left'
    },
    {
      campo: 'QTD',
      cabecalho: 'Quantidade',
      alinhamento: 'right'
    },
    {
      campo: 'valor',
      cabecalho: 'Valor',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatos.currency( v )
    },
    {
      campo: 'valorTotal',
      cabecalho: 'Total',
      alinhamento: 'right',
      format: ( v: number ) => clsFormatos.currency( v )
    },
    {
      campo: 'pgto',
      cabecalho: 'PG',
      alinhamento: 'left'
    }
  ]

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>( { descricao: '' } )
  const [rsOrdemServico, setRsOrdemServico] = useState<Array<OrdemServicoInterface>>( [] )

  const onClickPesquisa = ( oque: string ) => {

    const query = `
      getOrdensServicosPendentes(pesquisa: "${oque}") {
        idOrdemServico
        amostraInicial
        amostraFinal
        numeroOS
        empresa
        proprietario
        tipoAnalise
        valor
        valorTotal
        QTD
        pgto
        idFilial
        numeroOSInterna
      }
    `

    return clsApi.query<Array<OrdemServicoInterface>>( query, 'getOrdensServicosPendentes', 'Pesquisando Ordens de Serviços...', contexto, abortController ).then( rsOrdens => {

      setRsOrdemServico( rsOrdens )
      setRsSelecao( [] )

    } ).catch( ( e ) => {

      setMensagemState( {
        cb: null,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Ordens de Serviços Pendentes!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

      setRsOrdemServico( [] )

    } )

  }

  const novaFilialSelecionada = ( rs: FilialTypesInterface ) => {
    setDados( { ...ResetDados, idFilial: rs && rs.idFilial ? rs.idFilial : '' } )
    setRsClienteSelecionado( null )
    setRsParcelas( [] )
    refreshKey.current += 1
  }

  const onChangeCliente = ( novoCliente: ListarClientesOmieInterface | null ) => {
    setRsClienteSelecionado( novoCliente )
    onPesquisaObsDetalhadas( dados.idFilial, novoCliente ? novoCliente.codigo_cliente_omie : 0 ).then( rsOBS => {
      setDados( { ...dados, codigo_cliente: novoCliente ? novoCliente.codigo_cliente_omie : 0, email: novoCliente ? novoCliente.email : '', obs_detalhadas: rsOBS } )
    } )
  }

  const onPesquisaObsDetalhadas = ( idFilial: String, codigo_cliente_omie: number ): Promise<string> => {

    if ( codigo_cliente_omie ) {

      const query = `
        pesquisaObservacaoDetalhada(idFilial: "${idFilial}", codigo_cliente_omie: ${codigo_cliente_omie}) 
      `

      return clsApi.query<string>( query, 'pesquisaObservacaoDetalhada', 'Pesquisando Observação...', contexto, abortController ).then( rsOBS => {

        return rsOBS

      } ).catch( ( e ) => {

        setMensagemState( {
          cb: null,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao Consultar Parcelas!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

        return ''

      } )

    } else {

      return Promise.resolve( '' )

    }

  }

  const searchParcelas = ( idFilial: string ) => {

    const query = `
      getParcelasPorFilial(idFilial: "${idFilial}") {
        cDescricao
        nCodigo
        nParcelas
      }
    `

    return clsApi.query<Array<ParcelasOmieInterface>>( query, 'getParcelasPorFilial', 'Pesquisando Parcelas...', contexto, abortController ).then( rsParcelas => {

      setRsParcelas( rsParcelas )

    } ).catch( ( e ) => {

      setMensagemState( {
        cb: null,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Parcelas!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

      setRsParcelas( [] )

    } )

  }

  const onSearchCliente = ( pesquisa: string ): Promise<Array<ListarClientesOmieInterface>> => {

    if ( dados.idFilial.length > 0 ) {

      const query = `
        pesquisaClientePorRazaoSocial(idFilial: "${dados.idFilial}", pesquisa: "${pesquisa}") {
          codigo_cliente_omie
          nome_fantasia
          email
          obs_detalhadas
        }
      `

      return clsApi.query<Array<ListarClientesOmieInterface>>( query, 'pesquisaClientePorRazaoSocial', 'Pesquisando Permissões...', contexto, abortController ).then( rsClientes => {

        return searchParcelas( dados.idFilial ).then( () => {

          return rsClientes

        } )

      } ).catch( ( e ) => {

        setMensagemState( {
          cb: null,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao Consultar Clientes!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

        return []

      } )

    } else {

      setMensagemState( {
        cb: null,
        titulo: 'Forneça uma Filial',
        exibir: true,
        mensagem: 'Os clientes são separados por filiais!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

      return Promise.resolve( [] )

    }

  }

  const onSelecionarLinha = ( idOrdemServico: number ) => {

    let tmpSelecao: Array<number> = []

    if ( rsSelecao.includes( idOrdemServico ) ) {
      tmpSelecao = rsSelecao.filter( i => i !== idOrdemServico )
    } else {
      tmpSelecao = [...rsSelecao, idOrdemServico]
    }

    const { descricaoServico, dadosAdicionaisNF, valorTotal } = clsEnviarOS.gerarDados( rsOrdemServico, tmpSelecao )

    // console.log( valorTotal )

    setDados( {
      ...dados,
      descricaoServico: descricaoServico,
      dadosAdicionaisNF: dadosAdicionaisNF,
      valorTotal: valorTotal,
      idOrdemServico: [...tmpSelecao]
    } )

    setRsSelecao( tmpSelecao )
  }

  const setarIconeLinha = ( idOrdemServico: number ): string => {
    return rsSelecao.includes( idOrdemServico ) ? 'check_box' : 'check_box_outline_blank'
  }

  const onSelecionarTodos = () => {

    let tmpSelecao: Array<number> = []

    if ( rsSelecao.length === 0 ) {

      tmpSelecao = rsOrdemServico.map( rs => rs.idOrdemServico as number )

    }

    const { descricaoServico, dadosAdicionaisNF, valorTotal } = clsEnviarOS.gerarDados( rsOrdemServico, tmpSelecao )

    setDados( {
      ...dados,
      descricaoServico: descricaoServico,
      dadosAdicionaisNF: dadosAdicionaisNF,
      valorTotal: valorTotal,
      idOrdemServico: [...tmpSelecao]
    } )

    setRsSelecao( tmpSelecao )

  }

  const onGerarOS = () => {

    let tmpDados: GerarOrdemServicoInputInterface = { ...dados }

    tmpDados.idOrdemServico = [...rsSelecao];

    const mutation = `
          gerarOrdemServicos(dados: ${clsUtils.ConverterEmGql( dados )}) {
            ok
            mensagem
          }
        `

    return clsApi.mutation<RespostaPadraoInterface>( mutation, 'gerarOrdemServicos', 'Gerando Ordem de Serviços...', contexto, abortController ).then( rsResposta => {

      if ( rsResposta.ok ) {

        onClickPesquisa( pesquisa.descricao )

      } else {

        setMensagemState( {
          cb: null,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: rsResposta.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      }

    } ).catch( ( e ) => {

      setMensagemState( {
        cb: null,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Gerar Ordem de Serviços!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

      return []

    } )

  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Envio de OSs
                <Typography variant="body2" gutterBottom>
                  Envia Ordens de Serviços para o sistema Omie
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate( '/' )} >
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12}>

              <InputText
                dados={pesquisa}
                field='descricao'
                label='Pesquisar'
                setState={setPesquisa}
                iconeEnd="search"
                onClickIconeEnd={() => onClickPesquisa( pesquisa.descricao )}
                mapKeyPress={[{ key: 'Enter', onKey: ( () => { onClickPesquisa( pesquisa.descricao ) } ) }]}
              />

            </Grid>

            <Condicional condicao={rsOrdemServico && rsOrdemServico.length > 0}>

              <Grid item xs={12} sx={{ textAlign: 'right', mt: 5 }}>
                <Button variant='contained' onClick={() => onSelecionarTodos()}>{rsSelecao.length === 0 ? 'Selecionar Todas' : 'Limpar Seleção'}</Button>
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable<OrdemServicoInterface> dados={rsOrdemServico}
                  cabecalho={Cabecalho}
                  rowsPerPageOptions={[25, 50, 75, { value: rsOrdemServico && rsOrdemServico.length ? rsOrdemServico.length : 0, label: 'Todos' }]}
                  rowsPerPageInicial={25}
                  onSelecionarLinha={( rs ) => onSelecionarLinha( rs.idOrdemServico as number )}
                  acoes={[
                    { icone: ( rs ) => setarIconeLinha( rs.idOrdemServico as number ), toolTip: '', onAcionador: ( _rs, linha ) => onSelecionarLinha( linha ) }
                  ]} />
              </Grid>

              <Grid item xs={12} md={2}>
                <ComboBox
                  campoID='idTipoERP'
                  campoDescricao='descricao'
                  opcoes={FilialTypes}
                  dados={dados}
                  field='tipoERP'
                  setState={setDados}
                  label='Filial'
                  onChange={novaFilialSelecionada}
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>

                <SearchText<ListarClientesOmieInterface>
                  onSearch={onSearchCliente}
                  campoPesquisa='nome_fantasia'
                  campoID='codigo_cliente'
                  label='Cliente'
                  value={rsClienteSelecionado}
                  onChange={onChangeCliente}
                  key={refreshKey.current}
                />

              </Grid>

              <Grid item xs={12} md={2}>
                <ComboBox
                  campoID='nCodigo'
                  campoDescricao='cDescricao'
                  opcoes={rsParcelas}
                  dados={dados}
                  field='codigoParcela'
                  setState={setDados}
                  label='Parcela'
                />
              </Grid>

              <Grid item xs={12} md={10} sx={{ pl: { md: 1 } }}>

                <InputText
                  dados={dados}
                  setState={setDados}
                  field='email'
                  label='Email'
                  maxLength={255}
                />

              </Grid>

              <Grid item xs={12} sx={{ mt: 4 }}>

                <TextField
                  label='Descrição dos Serviços'
                  rows={10}
                  multiline
                  fullWidth
                  value={dados.descricaoServico}
                  onChange={( e ) => setDados( { ...dados, descricaoServico: e.target.value } )}
                />

              </Grid>

              <Grid item xs={12} sx={{ mt: 4 }}>

                <TextField
                  label='Dados Adicionais da NF'
                  rows={10}
                  multiline
                  fullWidth
                  value={dados.dadosAdicionaisNF}
                  onChange={( e ) => setDados( { ...dados, dadosAdicionaisNF: e.target.value } )}
                />

              </Grid>

              <Grid item xs={12} sx={{ mt: 4 }}>

                <TextField
                  label='Observações Detalhadas'
                  rows={10}
                  multiline
                  fullWidth
                  value={dados.obs_detalhadas}
                  onChange={( e ) => setDados( { ...dados, obs_detalhadas: e.target.value } )}
                />

              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'right', mt: 5 }}>
                <Button disabled={!rsSelecao.length || dados.codigo_cliente === 0 || dados.idFilial.length === 0} variant='contained' onClick={() => onGerarOS()}>Gerar OS</Button>
              </Grid>

            </Condicional>

          </Grid>

        </Paper>
      </Container >
    </>
  )

}